import "./ButtonIcon.css";
import Button from "@mui/material/Button";
import { FaListUl } from "react-icons/fa";

function ButtonIcon({
  backgroundColor,
  borderColor,
  color,
  icon,
  marginTop,
  buttonText,
  width,
  height,
  onClick,
  type,
  buttonFontSize=12
}) {
  return (
    <Button
      type={type}
      sx={{
        backgroundColor,
        color,
        width,
        borderColor,
        marginTop,
        height,
        fontSize: buttonFontSize,
        "&:hover": { backgroundColor, opacity: 0.7 },
      }}
      variant="outlined"
      startIcon={
        buttonText === "View all" ? (
          <FaListUl style={{ fontSize: 14 }} />
        ) : (
          icon && icon
        )
      }
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
}

export default ButtonIcon;
